import { useContext } from 'react';
import { UserSessionContext } from '../../contexts/UserSessionContext';

export const useUserSessionContext = () => {
  const ctx = useContext(UserSessionContext);
  if (!ctx) {
    throw new Error('useUserSessionContext must be used inside UserSessionProvider');
  }
  return ctx;
};
